import _ from '@lodash';
import { withRouter } from 'react-router-dom';
import ListView from './listView';


function EndUsersAccountsTable(props) {

	return (
		<div className="w-full flex flex-col">
			
			
			<SwitchView 
				gotoDetailsPage={props.gotoDetailsPage} 
			/>
			<div className="p-10" />
		</div>
	);

}

function SwitchView({
		gotoDetailsPage,
	}) {
		return(
			<ListView
				// endUsersAccounts={endUsersAccounts} 
				gotoDetailsPage={gotoDetailsPage}
			/>
		)
}

export default withRouter(EndUsersAccountsTable)
